module.exports = __webpack_public_path__ + "img/1f942.6782c9c.svg";